/**
 * Register Route
 *
 * Registration page that renders the RegisterPage component from pages/auth.
 * Follows the same pattern as other auth routes (login, check-email, verify-email).
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { RegisterPage } from "../../pages/auth";

export const Route = createFileRoute("/_auth/register")({
  component: RegisterRoute,
});

function RegisterRoute() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    // Navigate to check email page after successful registration
    navigate({ to: "/check-email" });
  };

  return <RegisterPage onSuccess={handleSuccess} />;
}
